var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-tile-macro.j2"] = require( "macros/product-tile-macro.j2" );
dependencies["macros/slider-macros.j2"] = require( "macros/slider-macros.j2" );
dependencies["./product-tray/headline.j2"] = require( "./product-tray/headline.j2" );
dependencies["./product-tray/carousel.j2"] = require( "./product-tray/carousel.j2" );
dependencies["./product-tray/grid.j2"] = require( "./product-tray/grid.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/contentful/product-tray-module-content.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-tile-macro.j2", false, "core/templates/contentful/product-tray-module-content.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayProductTile")) {
var t_4 = t_1.displayProductTile;
} else {
cb(new Error("cannot import 'displayProductTile'")); return;
}
context.setVariable("displayProductTile", t_4);
env.getTemplate("macros/slider-macros.j2", false, "core/templates/contentful/product-tray-module-content.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(context.getVariables(), frame, function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("create_slider_arrows")) {
var t_8 = t_5.create_slider_arrows;
} else {
cb(new Error("cannot import 'create_slider_arrows'")); return;
}
context.setVariable("create_slider_arrows", t_8);
var t_9;
t_9 = (lineno = 3, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["navType.slug",""]));
frame.set("currentNavSlug", t_9, true);
if(frame.topLevel) {
context.setVariable("currentNavSlug", t_9);
}
if(frame.topLevel) {
context.addExport("currentNavSlug", t_9);
}
output += "\n\n";
if((lineno = 5, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.headline"])) && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "tray")),"records")) > 0) {
output += "\n\n    ";
env.getTemplate("./product-tray/headline.j2", false, "core/templates/contentful/product-tray-module-content.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n";
})});
}
output += "\n\n";
var t_14;
t_14 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"productTileType");
frame.set("tileType", t_14, true);
if(frame.topLevel) {
context.setVariable("tileType", t_14);
}
if(frame.topLevel) {
context.addExport("tileType", t_14);
}
output += "\n";
var t_15;
t_15 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "entry")),"fields")),"displayType");
frame.set("displayType", t_15, true);
if(frame.topLevel) {
context.setVariable("displayType", t_15);
}
if(frame.topLevel) {
context.addExport("displayType", t_15);
}
output += "\n";
var t_16;
t_16 = (lineno = 13, colno = 40, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isFeatureEnabled"), "isFeatureEnabled", context, [runtime.contextOrFrameLookup(context, frame, "core"),"favorites"]));
frame.set("displayFavorites", t_16, true);
if(frame.topLevel) {
context.setVariable("displayFavorites", t_16);
}
if(frame.topLevel) {
context.addExport("displayFavorites", t_16);
}
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "tileType") == "NO_DETAILS") {
output += "\n    ";
var t_17;
t_17 = "c-product-tray--no-details";
frame.set("modifierClass", t_17, true);
if(frame.topLevel) {
context.setVariable("modifierClass", t_17);
}
if(frame.topLevel) {
context.addExport("modifierClass", t_17);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileType") == "TITLE_ONLY") {
output += "\n    ";
var t_18;
t_18 = "c-product-tray--title-only";
frame.set("modifierClass", t_18, true);
if(frame.topLevel) {
context.setVariable("modifierClass", t_18);
}
if(frame.topLevel) {
context.addExport("modifierClass", t_18);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileType") == "TITLE_AND_PRICE") {
output += "\n    ";
var t_19;
t_19 = "c-product-tray--title-and-price";
frame.set("modifierClass", t_19, true);
if(frame.topLevel) {
context.setVariable("modifierClass", t_19);
}
if(frame.topLevel) {
context.addExport("modifierClass", t_19);
}
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "tileType") == "REGULAR") {
output += "\n    ";
var t_20;
t_20 = "c-product-tray--regular-tile";
frame.set("modifierClass", t_20, true);
if(frame.topLevel) {
context.setVariable("modifierClass", t_20);
}
if(frame.topLevel) {
context.addExport("modifierClass", t_20);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_21;
t_21 = "";
frame.set("modifierClass", t_21, true);
if(frame.topLevel) {
context.setVariable("modifierClass", t_21);
}
if(frame.topLevel) {
context.addExport("modifierClass", t_21);
}
output += "\n";
;
}
;
}
;
}
;
}
output += "\n\n<div class=\"o-row\">";
var t_22;
t_22 = (lineno = 29, colno = 44, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get_from_obj"), "_get_from_obj", context, [runtime.contextOrFrameLookup(context, frame, "entry"),"fields.headline"]));
frame.set("productTrayHeadline", t_22, true);
if(frame.topLevel) {
context.setVariable("productTrayHeadline", t_22);
}
if(frame.topLevel) {
context.addExport("productTrayHeadline", t_22);
}
if(runtime.contextOrFrameLookup(context, frame, "productTrayHeadline")) {
output += "\n        ";
var t_23;
t_23 = runtime.contextOrFrameLookup(context, frame, "productTrayHeadline");
frame.set("eventActionName", t_23, true);
if(frame.topLevel) {
context.setVariable("eventActionName", t_23);
}
if(frame.topLevel) {
context.addExport("eventActionName", t_23);
}
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "slug")) {
var t_24;
t_24 = runtime.contextOrFrameLookup(context, frame, "slug");
frame.set("eventActionName", t_24, true);
if(frame.topLevel) {
context.setVariable("eventActionName", t_24);
}
if(frame.topLevel) {
context.addExport("eventActionName", t_24);
}
;
}
else {
var t_25;
t_25 = "product ids";
frame.set("eventActionName", t_25, true);
if(frame.topLevel) {
context.setVariable("eventActionName", t_25);
}
if(frame.topLevel) {
context.addExport("eventActionName", t_25);
}
;
}
;
}
output += "\n\n    ";
if(runtime.contextOrFrameLookup(context, frame, "displayType") == "CAROUSEL") {
output += "\n\n            ";
env.getTemplate("./product-tray/carousel.j2", false, "core/templates/contentful/product-tray-module-content.j2", null, function(t_28,t_26) {
if(t_28) { cb(t_28); return; }
t_26.render(context.getVariables(), frame, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
output += t_27
output += "\n\n            ";
if(runtime.contextOrFrameLookup(context, frame, "isSpecialtyShop")) {
output += "\n\n                <div class=\"o-slider-product-tray__pagination js-slider-product-tray__pagination\"></div>\n\n            ";
;
}
output += "\n\n            ";
output += runtime.suppressValue((lineno = 52, colno = 33, runtime.callWrap(t_8, "create_slider_arrows", context, [runtime.makeKeywordArgs({"nextAnalytics": (lineno = 52, colno = 50, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","tray_next",""])),"prevAnalytics": (lineno = 52, colno = 98, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ga"), "ga", context, ["marketing","tray_prev",""])),"isSmallArrow": runtime.contextOrFrameLookup(context, frame, "True"),"classPrefix": "slider-product-tray"})])), env.opts.autoescape);
output += "\n\n        </div>\n    ";
})});
}
else {
if(runtime.contextOrFrameLookup(context, frame, "displayType") == "GRID") {
output += "\n\n        ";
env.getTemplate("./product-tray/grid.j2", false, "core/templates/contentful/product-tray-module-content.j2", null, function(t_32,t_30) {
if(t_32) { cb(t_32); return; }
t_30.render(context.getVariables(), frame, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
output += t_31
output += "\n\n    ";
})});
}
;
}
output += "\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/contentful/product-tray-module-content.j2"] , dependencies)